import * as React from 'react';
import * as styled from './styled';
import useLockBodyScroll from 'helpers/useLockBodyScroll';
import useClickOutside from 'helpers/useClickOutside';
import {DrawerProps} from './types';

/**
 * The drawer component.
 * @param {DrawerProps} props
 * @return {React.ReactElement<DrawerProps>}
 * @constructor
 */
export default function Drawer(
    props: DrawerProps,
): React.ReactElement<DrawerProps> {
  const wrapperRef = React.createRef<HTMLDivElement>();
  const [containerWidth, setOpacity] = React.useState(0);

  React.useEffect(() => {
    setOpacity(1)
  }, [])

  /**
   * Lock the body scroll.
   */
  useLockBodyScroll();

  /**
   * The handle click outside of the wrapper.
   */
  useClickOutside(wrapperRef, () => {
    blur();
  });

  /**
   * The blur event.
   */
  function blur(): void {
    setOpacity(0);
    props.onBlur && setTimeout(props.onBlur, 100)
  }

  return (
    <styled.Overlay style={{opacity: containerWidth as number}}>
      <styled.Wrapper
        ref={wrapperRef}
        align={props.align}
      >
        {props.children}
      </styled.Wrapper>
    </styled.Overlay>
  );
}
